import {
    TOURNAMENTS_LIST_LOADING,
    TOURNAMENTS_LIST_SUCCESS,
    TOURNAMENTS_LIST_ERROR,
  } from "../../../constant/actionTypes";
  
  const listTournamentReducer = (state = {}, action) => {
    switch (action.type) {
      case TOURNAMENTS_LIST_LOADING: {
        let obj = {
          loading: true,
        };
        return obj;
      }
      case TOURNAMENTS_LIST_SUCCESS: {
        let obj = {
          loading: false,
          data: action.response,
        };
        return obj;
      }
      case TOURNAMENTS_LIST_ERROR: {
        let obj = {
          loading: false,
          status: action.response,
        };
        return obj;
      }
      default:
        return state;
    }
  };
  
  export default listTournamentReducer;
  